import { render } from "./informations.vue?vue&type=template&id=55583bd6&scoped=true"
import script from "./informations.vue?vue&type=script&lang=js"
export * from "./informations.vue?vue&type=script&lang=js"

import "./informations.vue?vue&type=style&index=0&id=55583bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55583bd6"]])

export default __exports__